import React from 'react';

const TrelloIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="2" y="2" width="20" height="20" rx="3" fill="#0079BF" />
    <rect x="5" y="5" width="6.2" height="13" rx="1.2" fill="#FFFFFF" />
    <rect x="12.8" y="5" width="6.2" height="9" rx="1.2" fill="#FFFFFF" />
  </svg>
);

export default TrelloIcon;
